const filterTypes = Object.freeze({
  STRING: "string",
  NUMERIC: "numeric",
  DATE: "date",
  BOOLEAN: "boolean",
  SELECTION: "selection"
});

const filterConditions = Object.freeze({
  EQUALS: "equals",
  NOT_EQUALS: "notEquals",
  // NULL: "null",
  // NOT_NULL: "notNull",
  LIKE: "like",
  // NOT_LIKE: "notLike",
  GT: "gt",
  GTE: "gte",
  LT: "lt",
  LTE: "lte"
  // IN: "in"
});

export { filterTypes, filterConditions };
